'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgList = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _g || (_g = /*#__PURE__*/React__namespace.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React__namespace.createElement("rect", {
  y: 1,
  width: 6,
  height: 5,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  x: 9,
  y: 1,
  width: 16,
  height: 5,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  y: 9,
  width: 6,
  height: 5,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  x: 9,
  y: 9,
  width: 16,
  height: 5,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  y: 17,
  width: 6,
  height: 5,
  rx: 1
}), /*#__PURE__*/React__namespace.createElement("rect", {
  x: 9,
  y: 17,
  width: 16,
  height: 5,
  rx: 1
}))));

exports["default"] = SvgList;
